// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  consignId: __t.u64().primaryKey().name("consign_id"),
  shipmentId: __t.u64().name("shipment_id"),
  firmId: __t.u64().name("firm_id"),
  orderId: __t.u64().name("order_id"),
  buyer: __t.identity(),
  stationKey: __t.string().name("station_key"),
  familyKey: __t.string().name("family_key"),
  priceSov: __t.i64().name("price_sov"),
  qty: __t.u32(),
  escrowSov: __t.i64().name("escrow_sov"),
  state: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
